.footer {
  border-top: 1px solid rgba(255, 255, 255, 0.1);
  margin-top: 5rem;
  background: linear-gradient(135deg, #1a1a1a 0%, #2d2d2d 100%);
}

.footer-section-title {
  color: #fff;
  font-size: 1rem;
  letter-spacing: 0.5px;
  padding-bottom: 0.75rem;
  border-bottom: 2px solid #007bff;
  display: inline-block;
  text-transform: uppercase;
  font-weight: 700;
}

.footer-links {
  padding-left: 0;
}

.footer-link {
  transition: all 0.3s ease;
  font-size: 0.95rem;
  color: rgba(255, 255, 255, 0.75);
  display: inline-flex;
  align-items: center;
  gap: 0.5rem;
}

.footer-link:before {
  content: '→';
  opacity: 0;
  transform: translateX(-5px);
  transition: all 0.3s ease;
}

.footer-link:hover {
  color: #00d4ff !important;
  text-decoration: none;
  padding-left: 0.5rem;
}

.footer-link:hover:before {
  opacity: 1;
  transform: translateX(0);
}

.footer hr {
  opacity: 0.2;
  margin: 2rem 0;
}

.footer p {
  font-size: 0.9rem;
  line-height: 1.6;
  color: rgba(255, 255, 255, 0.6);
}

.footer a {
  transition: color 0.3s ease;
}

.footer a:hover {
  color: #00d4ff !important;
}

/* Footer container styling */
.footer .container {
  max-width: 1200px;
}

/* Section background highlight on hover */
.footer .col-md-6,
.footer .col-lg-3 {
  transition: transform 0.3s ease;
}

.footer .col-md-6:hover,
.footer .col-lg-3:hover {
  transform: translateY(-2px);
}

/* Responsive design */
@media (max-width: 768px) {
  .footer {
    margin-top: 3rem;
    padding: 2rem 1rem;
  }

  .footer-section-title {
    font-size: 0.95rem;
    padding-bottom: 0.5rem;
  }

  .footer-link {
    font-size: 0.9rem;
  }

  .footer-links li {
    margin-bottom: 0.75rem !important;
  }

  .footer .row {
    display: grid;
    grid-template-columns: 1fr 1fr;
    gap: 1.5rem;
  }

  .footer hr {
    margin: 1.5rem 0;
  }

  .footer p {
    font-size: 0.85rem;
  }
}

@media (max-width: 480px) {
  .footer {
    padding: 1.5rem 0.5rem;
  }

  .footer-section-title {
    font-size: 0.9rem;
  }

  .footer .row {
    grid-template-columns: 1fr;
  }

  .footer-link {
    font-size: 0.85rem;
  }

  .footer .col-md-6 {
    text-align: center;
  }
}
